export interface ContactGroup {
  id: string;
  name: string;
  color: string;
  description?: string;
  createdAt: string;
}

export interface Contact {
  id: string;
  name: string;
  phone: string;
  email?: string;
  memo?: string;
  groupIds: string[];
  createdAt: string;
  lastSentAt?: string;
}

export const GROUP_COLORS = [
  { value: "violet", label: "바이올렛", bg: "bg-violet-500/20", text: "text-violet-400", border: "border-violet-500/30", dot: "bg-violet-400" },
  { value: "pink", label: "핑크", bg: "bg-pink-500/20", text: "text-pink-400", border: "border-pink-500/30", dot: "bg-pink-400" },
  { value: "emerald", label: "에메랄드", bg: "bg-emerald-500/20", text: "text-emerald-400", border: "border-emerald-500/30", dot: "bg-emerald-400" },
  { value: "amber", label: "앰버", bg: "bg-amber-500/20", text: "text-amber-400", border: "border-amber-500/30", dot: "bg-amber-400" },
  { value: "sky", label: "스카이", bg: "bg-sky-500/20", text: "text-sky-400", border: "border-sky-500/30", dot: "bg-sky-400" },
  { value: "rose", label: "로즈", bg: "bg-rose-500/20", text: "text-rose-400", border: "border-rose-500/30", dot: "bg-rose-400" },
];